<template>
  <modal name="order-form-component"
  transition="nice-modal-fade"
  classes="demo-modal-class"
  :min-width="300"
  :min-height="200"
  :pivot-y="0.5"
  :adaptive="true"
  :scrollable="true"
  :reset="true"
  width="40%"
  height="auto"
  @before-open="beforeOpen"
  @opened="opened"
  @closed="closed"
  @before-close="beforeClose">


  <div class="modal-modern-wrapper">
    <div class="modal-header">
      <button type="button" class="close d-inline" aria-label="Close" @click="close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <div v-if="isExpense(model)">
        <h4 v-if="model === undefined || !model.id" class="modal-title modern d-inline">NOVA DESPESA</h4>
        <h4 v-if="model === undefined || model.id" class="modal-title modern d-inline">VER DESPESA</h4>
      </div>
      <div v-if="isRevenue(model)">
        <h4 v-if="model === undefined || !model.id" class="modal-title modern d-inline">NOVA RECEITA</h4>
        <h4 v-if="model === undefined || model.id" class="modal-title modern d-inline">VER RECEITA</h4>
      </div>
    </div>
    <form class="modern" @submit.prevent="onSubmit()">
      <div class="modal-body">
        <div class="container">
          <div class="row">
            <div class="col-md-4 col-12">
              <div class="form-group">
                <label class="text-left" for="price">VALOR *</label>
                <money type="text" class="form-control" id="money-input" required v-model="model.value" placeholder="R$ 0,00" name="value" ></money>
              </div>

              <div class="form-group">
                <label for="account_id" class="control-label">CONTA *</label>
                <select class="form-control" v-model="model.account_id" name="account_id">
                  <option v-for="item of accounts" :value="item.id">{{ item.name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="payment_method_id" class="control-label">FORMA DE PAGAMENTO</label>
                <select class="form-control" v-model="model.payment_method_id" name="payment_method_id">
                  <option value="null">Selecione um método de pagamento...</option>
                  <option v-for="item of payment_methods" :value="item.id">{{ item.name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="name">VENCIMENTO *</label>
                <input type="date" class="form-control" v-model="model.due_date" name="due_date" required>
              </div>

            </div>

            <div class="col-md-8 col-12">
              <div class="p-3 pb-4" style="background-color: #f0f0f0"> 

                <div class="row">
                  <div class="col-md-12 col-12">
                    <div class="form-group">
                      <label for="name">DESCRIÇÃO *</label>
                      <input type="text" class="form-control bg-white" required v-model="model.name" name="name" >
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group">
                      <label for="name" ref="multiselect" id="closeDropdown">CATEGORIA *</label>
                        <multiselect 
                          :class="{ 'input-error-multiselect': formErrors.category }"
                          v-model="categoryId"
                          :options="categories"
                          :searchable="true"
                          :close-on-select="true" 
                          placeholder="Selecione..."
                          track-by="id"
                          selectLabel=""
                          selectedLabel="Selecionado"
                          deselectLabel="Selecionado"
                          noOptions="Carregando..."
                          label="name">
                          <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
                          <template slot="noResult" slot-scope="{ search }">
                            <span style="display: block;">Nehuma categoria encontrada</span>
                          </template>
                          <template slot="noOptions" slot-scope="{ search }">
                            <span style="display: block;">Carregando...</span>
                          </template>

                        </multiselect>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="isExpense(model)">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="customer_id">FORNECEDOR</label>
                      <select class="form-control bg-white" v-model="model.fornecedor_id">
                        <option value="null">Selecione um fornecedor...</option>
                        <option v-for="item of fornecedores" :value="item.codigo">{{ item.razao_nome }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="isRevenue(model)">
                  <div class="col-12">
                    <div class="form-group">
                      <label for="customer_id">CLIENTE</label>
                      <select class="form-control bg-white" v-model="model.cliente_id">
                        <option value="null">Selecione um cliente...</option>
                        <option v-for="item of clientes" :value="item.codigo">{{ item.nome_razao }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col-md-12 col-12">
                    <div class="form-group">
                      <label for="name">LINHA DIGITÁVEL</label>
                      <input type="text" class="form-control bg-white" v-model="model.identificador" name="identificador" >
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="row p-3">
          <div class="col-12 col-sm-4">
            <div class="form-check">
              <checkbox v-model="payCheckboxChecked">
                Recebido
              </checkbox>
              <input :required="payCheckboxChecked" class="form-control mt-2" :disabled="!payCheckboxChecked" v-model="model.pay_date" name="pay_date" type="date">
            </div>

          </div>
          <div class="col-12 col-sm-8">
            <div class="form-group pull-right" style="max-width: 200px; margin-top: 15px">
              <label for="name">COMPETÊNCIA</label>
              <input type="date" class="form-control" v-model="model.competence" name="competence">
            </div>
          </div>

         <!--  <div class="col-12 col-sm-8 row" v-if="!model.id">
            <div class="col-4">
              <checkbox v-model="repeatChecked">
                Repetir
              </checkbox>
            </div>
            <div class="col-3">
              <checkbox v-if="repeatChecked" v-model="foreverChecked">
                Sempre
              </checkbox>
            </div>
            <div class="form-check row ml-3" v-if="repeatChecked">
              <p class="d-inline">Nº repetições</p>
              <input type="number" :disabled="foreverChecked" min="1" max="999" class="form-control d-inline ml-1" style="max-width: 80px;" placeholder="">
              <select v-model="model.repeat_period" class="form-control d-inline ml-1 mt-2" style="max-width: 180px;" :required="repeatChecked">
                <option value="">Selecione a Periodicidade...</option>
                <option value="daily">Diariamente</option>
                <option value="weekly">Semanalmente</option>
                <option value="monthly">Mensalmente</option>
                <option value="yearly">Anualmente</option>
              </select>
            </div>
          </div> -->
        </div>
      </div>
      <div class="modal-footer">
        <div v-if="model.id && !areYouSure" class="modal-delete-area" @click="remove(model)">
          <i class="fa fa-trash-o"></i>
          <a class="delete-area mr-auto ml-1">Excluir</a>
        </div>
        <div v-if="model.id && areYouSure" class="modal-delete-area red" @click="removeAgain(model)">
          <i class="fa fa-trash-o"></i>
          <a class="delete-area mr-auto ml-1">Toque novamente</a>
        </div>
        <button type="button" class="btn modern btn-secondary" @click="close()">CANCELAR</button>
        <button type="submit" class="btn modern btn-success" v-bind:class="{ disabled:  loading }">
          <span v-if="model.id">SALVAR</span>
          <span v-if="!model.id">CRIAR</span>
        </button>
      </div>
    </form>

  </div>

</modal>
</template>
<script>
  import PaymentMethodService from '@/services/PaymentMethodService'
  import AccountService from '@/services/AccountService'
  import OrderService from '@/services/OrderService'
  import FornecedorService from '@/services/FornecedorService'
  import CategoryService from '@/services/CategoryService'
  import ClienteService from '@/services/ClienteService'
  import Checkbox from '@/components/Inputs/Checkbox'
  import moment from 'moment'
  import Multiselect from 'vue-multiselect'
  export default {
    name: 'OrderFormComponent',
    components: {
      Checkbox,
      Multiselect
    },
    computed: {
      categoryId: {
        get() {
            return this.categories.find(category => this.model.category_id === category.id);
        },
        set(val) {
          if(val) {
            this.model.category_id = val.id;
          } else {
            this.model.category_id = null;
          }
        },
      }
    },
    watch: {
      payCheckboxChecked(data) {
        if(!data) {
          this.model.pay_date = null;
        }
      }
    },
    data () {
      return {
        value: 0,
        model: {
          value: 0,
          payment_method_id: null,
        },
        payment_methods: [],
        addInformation: false,
        services: [],
        payCheckboxChecked: false,
        loading: false,
        categories: [],
        fornecedores: [],
        clientes: [],
        areYouSure: false,
        formErrors: {
          category: false,
        },
        repeatChecked: false,
        foreverChecked: false,
        accounts: [],
      }
    },
    methods: {
      beforeOpen (event) {
        this.repeatChecked = false;
        this.foreverChecked = false;
        this.model = Object.assign({}, event.params.order)

        if(!this.model.due_date) {
          this.model.due_date = moment().format('YYYY-MM-DD')
        } else {
          this.model.due_date = moment(this.model.due_date).format('YYYY-MM-DD')          
        }

        // console.log(this.model)

        if(this.model.competence) {
          this.model.competence = moment(this.model.competence).format('YYYY-MM-DD')
        }

        if(this.model.pay_date) {
          this.payCheckboxChecked = true;
          this.model.pay_date = moment(this.model.pay_date).format('YYYY-MM-DD')
        } else {
          this.payCheckboxChecked = false;
        }

        this.categoryId = { id: this.model.category_id }
      },
      beforeClose () {
      },
      opened (e) {
        this.formErrors.category = false;
        this.loadAccounts()
        this.loadCategories()
        let money = document.getElementById('money-input')
        money.focus()
      },
      closed (e) {
      },
      close() {
        this.$modal.hide('order-form-component')
      },
      getPagamentoTipoNome(tipo) {
        if(tipo == "C") {
          return "Entrada"
        }
        if(tipo == "D") {
          return "Saída"
        }

        return '';
      },

      hasErrors() {
        let achou = false; 

        for (var prop in this.formErrors) {
          if (Object.prototype.hasOwnProperty.call(this.formErrors, prop)) {
            if(this.formErrors[prop] == true) {
              achou = true;
            }
          }
        }

        return achou;
      },

      onSubmit() {
        if(!this.model.category_id) {
          this.formErrors.category = true;
        } else {
          this.formErrors.category = false;
        }

        if(this.hasErrors()) {
          return;
        }

        this.loading = true;

        OrderService.createOrUpdate(this.model).then(res => {
          this.$emit('change')
          this.loading = false;
          this.close()
        })
        .catch(err => {
          this.loading = false;

        })
      },

      isExpense(order) {
        if(order.type == 'e') {
          return true
        }

        return false;
      },

      isRevenue(order) {
        if(order.type == 'r') {
          return true
        }

        return false;
      },
      loadPaymentMethods() {
        PaymentMethodService.load().then(res => {
          this.payment_methods = res.data
        })
      },
      loadFornecedores() {
        FornecedorService.load().then(res => {
          this.fornecedores = res.data
        })
      },
      loadClientes() {
        ClienteService.load('?no_paginate=true').then(res => {
          this.clientes = res.data
        })
      },
      loadCategories() {
        CategoryService.load('?type=' + this.model.type).then(res => {
          let categories = res.data.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 
          this.categories = categories
        })
      },
      newCategory(name) {
        let closeDropdown = document.getElementById('categoryMultiselect');
        // closeDropdown.close()
        this.$refs.multiselect.deactivate()
      },
      remove(order) {
        this.areYouSure = true
        setTimeout(() => {
          this.areYouSure = false;
        }, 2000)
      },
      removeAgain(order) {
        OrderService.remove(order.id).then(res => {
          this.$emit('change')
          this.close()
        }).catch(err =>{

        })
      },
      loadAccounts() {
        AccountService.load().then(res => {
          this.accounts = res.data
          if(res.data.length) {
            if(!this.model.id) {
              for(let account of this.accounts) {
                if(account.default) {
                  this.model.account_id = account.id
                }
              }
            }
          }
        })
        .catch(err => {
          console.error(err)
        })
      }
    },
    mounted() {
      this.loadPaymentMethods()
      this.loadFornecedores()
      this.loadClientes()
    }
  }
</script>
<style>
.size-modal-content {
  padding: 10px;
  font-style: 13px;
}
.v--modal-overlay[data-modal="size-modal"] {
  background: rgba(0, 0, 0, 0.5);
}
.demo-modal-class {
  border-radius: 5px;
  background: #FFFFFF;
  box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
  z-index: 99999999;
  margin: 0 auto;
  left: 0 !important;
  margin-top: 20px;
  width: 60% !important;
  max-width: 750px;
}
.show{
  opacity: 1 !important;
}
.step{
  opacity: 0;
  transition: .5s ease-in-out all;
}

.modal-header h4 {
  position: absolute;
  left: 15px;
  top: -14px;
  font-size: 18px;
}

.ui.selection.dropdown {
  border-radius: 25px !important;
}
.multiselect__single {
  font-size: 12px !important;
}
.multiselect__input {
  font-size: 12px !important;
}
.multiselect__option {
  font-size: 12px !important;
}
.multiselect__tags {
  min-height: auto !important;
  border-radius: 20px !important;
  /*padding: 4px 40px 0 4px !important;*/
}

.modal-delete-area {
  position: absolute;
  left: 15px;
  bottom: 25px;
  padding: 10px;
  cursor: pointer;
}

.modal-delete-area:hover {
  background-color: #efefef;
}

.modal-delete-area.red {
  color: red;
}

.input-error {
  border: 1px solid red;
}

.input-error-multiselect > .multiselect__tags {
  border: 1px solid red;
}

.multiselect__tags {
  transition: border 1s;
}

@media (max-width: 600px) {
  .demo-modal-class {
    width: 90% !important;
  }
}
</style>